<template>
  <div class="d-flex align-center justify-center topBar height_6xl w-100 bg-white">
    <div class="d-flex justify-space-between w-100 topBar-content">
      <div class="d-flex align-center topBar-content_left">
        <a href="/dashboard" @click="trackLogoClick">
          <SvgFactory name="icon_purple_full_logo" is-horizontal :width="160" />
        </a>
      </div>
      <div
        v-if="useNewTopBar"
        class="topBar-content_center"
      >
        <SearchCompany />
      </div>
      <div class="d-flex align-center topBar-content_right">
          <Profile @open-change-user-modal="showChangeUserDialog = true" />
      </div>
    </div>

    <ChangeUserModal
      v-if="showChangeUserDialog"
      :show="showChangeUserDialog"
      @userSelected="changeUser"
      @close="showChangeUserDialog = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SvgFactory from '@design_system_v2/atoms/SvgFactory.vue';
import { tracker } from '@services/tracker';
import NavLink from '@/components/NavigationBarAtoms/NavLink.vue';
import Profile from '@/components/NavigationBarAtoms/Profile.vue';
import ChangeUserModal from '@/components/NavigationBarAtoms/ChangeUserModal.vue';
import SearchCompany from '@/components/NavigationBarAtoms/SearchCompany.vue';

export default {
  name: 'TopBar',
  components: {
    ChangeUserModal,
    NavLink,
    SvgFactory,
    Profile,
    SearchCompany,
  },
  emits: ['item-click'],
  data: () => ({
    showChangeUserDialog: false,
  }),
  computed: {
    ...mapGetters('main', [
      'navInfo',
      'featureFlags',
      'infoUser',
      'notificationsCount',
      'userProfile',
    ]),
    meList() {
      const myProfile = `/user/${this?.infoUser?.contactId}`;
      const list = [{ title: 'View my profile', path: myProfile }];

      // Only managers get the document views
      if (this.infoUser.CompanyTypeID === 1) {
        const myFunds = `/funds/company/${this?.infoUser?.companyId}/overview`;
        list.push({ title: 'View funds', path: myFunds });
        list.push({ title: 'My connections', path: '/connections' });
        list.push({ title: 'Document views', path: '/user/who_downloaded_documents' });
        list.push({ title: 'Allocator activity', path: '/user/allocator_activity' });
      } else {
        // my funds should be above my connections for managers
        list.push({ title: 'My connections', path: '/connections' });
      }

      if (this.infoUser.CompanyTypeID === 2) {
        const companyId = this.userProfile?.companyId;
        const investorPreferenceId = this.userProfile?.investorPreferenceId;
        const myInvestorPreference = `/allocators/company/${companyId}/allocator/${investorPreferenceId}/overview`;
        list.push({ title: 'View Investment Preferences', path: myInvestorPreference });
        list.push({ title: 'Company profile views', path: '/user/who_viewed_my_company' });
      }

      // Only show this for iConnection and radcliffefunds (ICP-12047) accounts
      const emailDomain = this.infoUser.email.split('@')[1].toLowerCase();
      if (emailDomain === 'iconnections.io' || emailDomain === 'radcliffefunds.com') {
        list.push({ title: 'Change user', path: '/change_user' });
      }

      if (this.infoUser.CompanyTypeID === 4) {
        list.push({
          title: 'Copilot v2',
          path: 'https://copilot.iconnections.io',
          event: 'navbar_copilot_click',
        });
        list.push({
          title: 'Copilot v3',
          path: 'https://copilotv3.iconnections.io',
          event: 'navbar_copilot3_click',
        });
      }

      list.push(
        { title: 'Settings', path: '/user/profile_settings/profile' },
        { title: 'Logout', path: '/logout' },
      );

      return list;
    },
    isAiSelected() {
      return this.$route.path.startsWith('/ai');
    },
    isChatSelected() {
      return this.$route.path.startsWith('/messages');
    },
    isContactsSelected() {
      return this.$route.path.startsWith('/contacts');
    },
    isInboxSelected() {
      return this.$route.path.startsWith('/inbox');
    },
    isScheduleSelected() {
      const currentPath = this.$route.path;
      return (
        currentPath.startsWith('/meetings')
        || (currentPath.startsWith('/roadshows') && currentPath.includes('my-roadshows'))
      );
    },
    useNewTopBar() {
      return this.infoUser.CompanyTypeID === 1 || this.infoUser.CompanyTypeID === 2;
    },
  },
  methods: {
    trackContactsClick(item) {
      tracker('contacts_click');
      this.itemClick(item);
    },
    trackLogoClick() {
      tracker('navbar_iconnections');
    },
    itemClick(item) {
      if (this.meList.includes(item)) {
        tracker('navbar_me_click', { option: item.title });
      }
      if (item.path === '/ai') {
        tracker('navbar_ai_assistant_click');
      }
      if (item.path === '/messages') {
        tracker('navbar_chats_click');
      }
      if (item.path === '/meetings') {
        tracker('navbar_schedule_click');
      }
      if (item.path === '/change_user') {
        this.showChangeUserDialog = true;
        return;
      }
      this.$emit('item-click', item);
    },
    changeUser(payload) {
      window.postMessage({ name: 'iConnectionsEventBus', type: 'changeUser', payload }, '*');
    },
  },
};
</script>

<style scoped lang="scss">
@import '@foundation';

.topBar {
  border-bottom: 1px solid map-get($neutral, 'neutral-300');
  &-content {
    max-width: 1280px;
    &_right {
      gap: 16px;
    }
  }
}

.topBar-content_center {
  flex-grow: 1;
  max-width: 624px;
}
</style>
